import { useContext } from 'react';
import { ModalContext } from './ModalContext';
import { Modal } from '@shopify/app-bridge-react';

export const ModalElement = () => {
  const { modalState, setModalState } = useContext(ModalContext);

  const handleCloseModal = () => {
    setModalState({
      ...modalState,
      open: false
    });
  };

  const primaryAction = modalState.primaryAction ? {
    destructive: modalState.isPrimaryDestructive,
    content: modalState.primaryActionLabel,
    onAction: modalState.primaryAction,
  } : undefined;

  const secondaryActionLabel = "Cancel";

  const modalMarkup = (
    <Modal
      open={modalState.open}
      onClose={handleCloseModal}
      title={modalState.title}
      message={modalState.message}
      primaryAction={primaryAction}
      secondaryActions={[
        {
          content: secondaryActionLabel,
          onAction: handleCloseModal
        }
      ]}
    />
  );

  return modalMarkup;
}
